import {
  Button,
  MenuItem,
  FormControl,
  FormControlLabel,
  Select,
  TextField,
  Typography,
  InputLabel,
  Switch,
  Grid,
  Card,
  CardContent
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { checkAutoLogin } from 'src/actions/getTokenActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import moment from 'moment';


const ListToolbarFilter = React.memo(({
  handleSetCompression, handleSetFrom, handleSetTo, handleSetDatacenter, handleSetRack, handleSetCirciut, handleSetPhase, 
  resetquery,handleIsAcceptInterpolate, handleSetAccountId ,sethowdetails, Datacenter,  AccountId, disableFilter, ...rest
 }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const isLogin = useSelector(state => state.gettocken.islogin);
  
  const [accountlist, setaccountlist] = useState([]);
  const [accountid, setaccountid] = useState([]);
  const [From, setFrom] = useState(moment.utc().subtract(1, 'day').format());
  const [To, setTo] = useState(moment.utc().format());
 // const [compression, setcompression] = useState('none');
  const [compression, setcompression] = useState('day');
  const [datacenterlist, setdatacenterlist] = useState([]);
  const [datacenter, setdatacenter] = useState('');
  const [racklist, setracklist] = useState([]);
  const [rack, setrack] = useState('');
  const [circuitlist, setcircuitlist] = useState([]);
  const [circuit, setcircuit] = useState('');
  const [phaselist, setphaselist] = useState([]);
  const [phase, setphase] = useState('');
  const [IsAcceptInterpolate, setIsAcceptInterpolate] = useState(true);

   const handlechecbox = (e) => {
    setIsAcceptInterpolate(!IsAcceptInterpolate)
    handleIsAcceptInterpolate(!IsAcceptInterpolate) 
   }

  const handleChangeFrom = (newValue) => {
    let valTime = newValue.utc().format()
    //setFrom(newValue.utc().format());
    setFrom(valTime);
   // handleSetFrom(newValue.utc().format())

    handleSetFrom(valTime)

  };

  const handleChangeTo = (newValue) => {
    let valTime = newValue.utc().format()
    // setTo(newValue.utc().format());
    setTo(valTime)
    // handleSetTo(newValue.utc().format())
    handleSetTo(valTime)
  };

  const handleCompressionFilter = (event) => {
    setcompression(event.target.value)
    handleSetCompression(event.target.value)
  }

  const handleCAccountIdFilter = (event) => {
    setaccountid(event.target.value)
    handleSetAccountId(event.target.value)
    sethowdetails(false)
  }

  const handleAccountIdDEFAULT = (id) => {
    setaccountid(id)
    handleSetAccountId(id)
    sethowdetails(false)
  }

  const handlesetdatacenter = (event) => {
    getracksbydatacenter(event.target.value)
    getcircuitbydatacenter(event.target.value)
    setdatacenter(event.target.value)
    handleSetDatacenter(event.target.value)
    sethowdetails(false)
  }
  const setDataCenterDEFAULT = (datacenterName) => 
  {
    console.log(datacenterName)
    getracksbydatacenter(datacenterName)
    getcircuitbydatacenter(datacenterName)
    setdatacenter(datacenterName)
    handleSetDatacenter(datacenterName)
    sethowdetails(false)
  }

  const handlesetrack = (event) => {
    setrack(event.target.value)
    handleSetRack(event.target.value)
  }

  const handlesetcircuit = (event) => {
    if (event.target.value === ""){
        setcircuitlist([])
    } else {
    getphasebycircuidId(event.target.value)
    setcircuit(event.target.value)
    handleSetCirciut(event.target.value)
    }
  }

  const handlesetphase = (event) => {
    if (event.target.value === ""){
        setphaselist([])
    } else {
    setphase(event.target.value)
    handleSetPhase(event.target.value)
     }
    }


  const resetfilter = () => {
    
    setFrom(moment.utc().subtract(1, 'month').format())
    setTo(moment.utc().format())
    setcompression('day')
    setdatacenter('')
    setracklist([])
    setrack('')
    setcircuitlist([])
    setaccountid('')
    setcircuit('')
    setphaselist([])
    setphase('')
    resetquery()
    sethowdetails(false)
  }

  useEffect(() => {
    const apiurl = sessionStorage.getItem('apiurl')
    console.log("Apiurl", apiurl)
    let token = checkAutoLogin(dispatch)
    if(!token && isLogin === false) {
     navigate('/login', { replace: true });
    } else {
      axios.get(`https://${apiurl}/api/DataCenter`, {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        }}).then( res => {
          setdatacenterlist(res.data)
          res.data[0] && setDataCenterDEFAULT(res.data[0].id)
        })

        axios.get(`https://${apiurl}/api/Account`, {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        }}).then( res => {
          let newaccount = res.data.filter(account => account.id !== 1)
          setaccountlist(newaccount)
          handleAccountIdDEFAULT(newaccount[0].id)
        })


    }
  }, [isLogin])


  const getracksbydatacenter = (datacenterid) => {
    let token = checkAutoLogin(dispatch)
    axios.get(`https://${apiurl}/api/Racks/${datacenterid}`, {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        }}).then( res => {
          setracklist(res.data)
        })
  }

  const getcircuitbydatacenter = (datacenterid) => {
    let token = checkAutoLogin(dispatch)
    axios.get(`https://${apiurl}/api/Circuit/GetByDataCenterId/?dataCenterId=${datacenterid}`, {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        }}).then( res => {
          setcircuitlist(res.data)
        })
  }

  const getphasebycircuidId = (circuidId) => {
    let token = checkAutoLogin(dispatch)
    axios.get(`https://${apiurl}/api/Phase/GetByCircuidId/?circuidId=${circuidId}`, {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        }}).then( res => {
          setphaselist(res.data)
        })
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
   <Card> 
    <CardContent>
  <Grid container spacing={2}>
        <Grid item xs={3} md={3}>
          <DateTimePicker
          label="Datum von"
          inputFormat="DD.MM.YYYY"
          views={['day']}
          value={From}
          onChange={handleChangeFrom}
          renderInput={(params) => <TextField {...params} />}
          disabled={disableFilter}
        />
        </Grid>
        <Grid item xs={3} md={3}>
        <DateTimePicker
          label="Datum bis"
          views={['day']}
          inputFormat="DD.MM.YYYY"
          value={To}
          onChange={handleChangeTo}
          renderInput={(params) => <TextField {...params} />}
          disabled={disableFilter}
        />
      </Grid>
      <Grid item xs={2} md={2}>
      <FormControl fullWidth> 
      <InputLabel id="demo-simple-select-autowidth-label">Verdichtung</InputLabel> 
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Verdichtung"
          value={compression}
          onChange={handleCompressionFilter}
          disabled={disableFilter}
          
        >
          <MenuItem value="none">keine Verdichtung</MenuItem>
          <MenuItem value="day">Tag</MenuItem>
          <MenuItem value="month">Monat</MenuItem>
          <MenuItem value="year">Jahr</MenuItem>
        </Select>
      </FormControl>
      </Grid> 
      <Grid item xs={4} md={4}></Grid>
    
      {/* <Grid item xs={2} md={2} >
      <Button  variant="outlined"  onClick={()=>handleshowfilter()}>mehr Optionen</Button>
      </Grid> */}
      </Grid>
      {/* {showfilter && */}
       <Grid container spacing={2} pt={2}>
      <Grid item xs={4} md={4}>
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-autowidth-label">Kunde</InputLabel>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         label="Kunde"
         value={accountid}
         disabled={disableFilter}
         onChange={handleCAccountIdFilter}
        // error = {Datacenter === "" && AccountId === ""}
       >
        <MenuItem value="">Bitte wählen Sie einen Kunden aus</MenuItem>
        {accountlist.map((item)=>{
        return(
            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            )
        })}
         
       </Select>
     </FormControl>

      </Grid>
    
      <Grid item xs={4} md={4}>
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-autowidth-label">Datencenter</InputLabel>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         label="Datacenter"
         value={datacenter}
         onChange={handlesetdatacenter}
         disabled={disableFilter}
        // error = {Datacenter === "" && AccountId === ""}
       >
        <MenuItem value="">Bitte wählen Sie ein Datencenter aus</MenuItem>
        {datacenterlist.map((item)=>{
        return(
            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            )
        })}
         
       </Select>
     </FormControl>
      </Grid>
      <Grid item xs={4} md={4}>
      {racklist.length !== 0 && Datacenter !== "" &&
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-autowidth-label">Racks</InputLabel>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         label="Datacenter"
         value={rack}
         onChange={handlesetrack}
         disabled={disableFilter}
       >
        <MenuItem value="">Bitte wählen Sie ein Rack</MenuItem>
        {racklist.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          }).map((item)=>{
        return(
            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            )
        })}
         
       </Select>
     </FormControl>
     }
      </Grid>
      
      
      <Grid item xs={4} md={4}>
      {circuitlist.length !== 0 &&
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-autowidth-label">Stromkreis</InputLabel>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         label="Datacenter"
         value={circuit}
         onChange={handlesetcircuit}
         disabled={disableFilter}
       >
        
        {circuitlist.map((item)=>{
        return(
            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            )
        })}
         
       </Select>s
     </FormControl>
     }
      </Grid>
     
      <Grid item xs={4} md={4}>
      {phaselist.length !== 0 &&
      <FormControl fullWidth>
      <InputLabel id="demo-simple-select-autowidth-label">Phase</InputLabel>
       <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         label="Datacenter"
         value={phase}
         onChange={handlesetphase}
         disabled={disableFilter}
       >
        {phaselist.map((item)=>{
        return(
            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
            )
        })}
         
       </Select>
     </FormControl>
     }
      </Grid>
      <Grid item xs={4} md={4}></Grid>
      <Grid item xs={4} md={4}>
      <Typography pl={3} >
          <FormControlLabel control={<Switch  checked={IsAcceptInterpolate} disabled={disableFilter} onChange={handlechecbox} />} label="Interpolierte Werte" />
          </Typography>
      </Grid>
    
      <Grid item xs={4} md={4}> <Button variant="outlined" color="error" disabled={disableFilter} onClick={()=>resetfilter()}>Filter zurücksetzen</Button></Grid>
</Grid>
               {/* } */}
     
     </CardContent>
     </Card>  
          
     
  
 
  </LocalizationProvider>
);
});
ListToolbarFilter.propTypes = {
  searchItem: PropTypes.any,
  searchFailed: PropTypes.bool,
  placeHolder: PropTypes.string
};

export default ListToolbarFilter;
